'use client';

import { useEffect } from 'react';

export default function ClientWrapper({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Intercept errors at the window level before they reach React
    const handleError = (event: ErrorEvent) => {
      if (event.error?.message?.includes('Connection closed')) {
        event.preventDefault();
        event.stopPropagation();
        console.warn('[Client Wrapper] Prevented connection closed error from propagating');
        return false;
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (event.reason?.message?.includes('Connection closed')) {
        event.preventDefault();
        event.stopPropagation();
        console.warn('[Client Wrapper] Prevented connection closed rejection from propagating');
        return false;
      }
    };

    window.addEventListener('error', handleError, true); // Use capture phase
    window.addEventListener('unhandledrejection', handleUnhandledRejection, true);

    // Also override Promise rejection handling
    const originalPromiseReject = Promise.reject;
    (Promise as any).reject = function(reason: any) {
      if (reason?.message?.includes('Connection closed')) {
        console.warn('[Client Wrapper] Intercepted Promise rejection with connection closed');
        return Promise.resolve(); // Convert to resolved promise
      }
      return originalPromiseReject.call(Promise, reason);
    };

    return () => {
      window.removeEventListener('error', handleError, true);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection, true);
      Promise.reject = originalPromiseReject;
    };
  }, []);

  return <>{children}</>;
} 